import script from "./PopularCategoriesLinksComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularCategoriesLinksComponent.vue?vue&type=script&setup=true&lang=js"

import "./PopularCategoriesLinksComponent.vue?vue&type=style&index=0&id=10f39daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f39daa"]])

export default __exports__